import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15273906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ftl-order" }
const _hoisted_2 = { class: "ftl-order__container" }
const _hoisted_3 = { class: "container__slot" }
const _hoisted_4 = { class: "container__statuses" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_enter_carrier_data_intracity = _resolveComponent("enter-carrier-data-intracity")!
  const _component_ftl_on_the_way = _resolveComponent("ftl-on-the-way")!
  const _component_enter_delivered_data_intracity = _resolveComponent("enter-delivered-data-intracity")!
  const _component_enter_completed_data_intracity = _resolveComponent("enter-completed-data-intracity")!
  const _component_upload_ftl_order_scan = _resolveComponent("upload-ftl-order-scan")!
  const _component_upload_ftl_stock_scan = _resolveComponent("upload-ftl-stock-scan")!
  const _component_ftl_order_state = _resolveComponent("ftl-order-state")!
  const _component_ftl_order_header = _resolveComponent("ftl-order-header")!
  const _component_ftl_order_tabs = _resolveComponent("ftl-order-tabs")!
  const _component_ftl_order_general = _resolveComponent("ftl-order-general")!
  const _component_ftl_order_cargo = _resolveComponent("ftl-order-cargo")!
  const _component_ftl_order_payment = _resolveComponent("ftl-order-payment")!
  const _component_ftl_order_sender_and_stops = _resolveComponent("ftl-order-sender-and-stops")!
  const _component_ftl_order_vehicle = _resolveComponent("ftl-order-vehicle")!
  const _component_ftl_order_files = _resolveComponent("ftl-order-files")!
  const _component_ftl_order_statuses = _resolveComponent("ftl-order-statuses")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_carrier)
      ? (_openBlock(), _createBlock(_component_enter_carrier_data_intracity, {
          key: 0,
          "ftl-type": _ctx.state.ftlOrder?.ftl_type,
          "shipment-type": _ctx.state.ftlOrder?.shipment_type_id,
          "is-need-car": _ctx.state.ftlOrder?.is_need_car,
          onSubmitted: _ctx.enterCarrierDataSubmit,
          onCancel: _ctx.toggleCarrier
        }, null, 8, ["ftl-type", "shipment-type", "is-need-car", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_on_the_way)
      ? (_openBlock(), _createBlock(_component_ftl_on_the_way, {
          key: 1,
          "is-loading": _ctx.state.is_on_the_way_loading,
          "order-id": _ctx.$route.params.order_id,
          onSubmit: _ctx.onTheWaySubmit,
          onCancel: _ctx.onTheWayCancel
        }, null, 8, ["is-loading", "order-id", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_delivered_intracity)
      ? (_openBlock(), _createBlock(_component_enter_delivered_data_intracity, {
          key: 2,
          "is-loading": _ctx.state.is_delivered_intracity_loading,
          "sender-city": _ctx.state.ftlOrder?.sender?.city,
          "ftl-type": _ctx.state.ftlOrder?.ftl_type,
          "status-code": _ctx.state.ftlOrder?.status_code,
          "is-need-car": _ctx.state.ftlOrder?.is_need_car,
          "additional-services": _ctx.state.ftlOrder?.shared_additional_service,
          onSubmitted: _ctx.onDeliveredIntracitySubmit,
          onCancel: _ctx.onDelieveredIntracityCancel
        }, null, 8, ["is-loading", "sender-city", "ftl-type", "status-code", "is-need-car", "additional-services", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_complete_intracity)
      ? (_openBlock(), _createBlock(_component_enter_completed_data_intracity, {
          key: 3,
          "is-loading": _ctx.state.is_complete_intracity_loading,
          "ftl-order": _ctx.state.ftlOrder,
          "additional-services": _ctx.state.ftlOrder?.additional_service,
          "sender-address": _ctx.state.ftlOrder?.sender?.full_address,
          stocks: _ctx.state.ftlOrder?.stock_delivery_notes,
          "status-code": _ctx.state.ftlOrder?.status_code,
          downtime: _ctx.state.ftlOrder?.downtime,
          "payment-rate-type-id": _ctx.state.ftlOrder?.downtime?.type,
          onSubmitted: _ctx.onCompleteIntracitySubmit,
          onCancel: _ctx.onCompleteIntracityCancel
        }, null, 8, ["is-loading", "ftl-order", "additional-services", "sender-address", "stocks", "status-code", "downtime", "payment-rate-type-id", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_scan_upload)
      ? (_openBlock(), _createBlock(_component_upload_ftl_order_scan, {
          key: 4,
          "ftl-order-id": _ctx.$route.params.order_id,
          "invoice-number": _ctx.state.ftlOrder.invoice_number,
          onSubmitted: _ctx.onScanUploadSubmit,
          onCancel: _ctx.onScanUploadCancel
        }, null, 8, ["ftl-order-id", "invoice-number", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.upload_ftl_stock_scan.is_opened)
      ? (_openBlock(), _createBlock(_component_upload_ftl_stock_scan, {
          key: 5,
          "ftl-stock-id": _ctx.upload_ftl_stock_scan.ftl_stock_id,
          "direction-name": _ctx.upload_ftl_stock_scan.ftl_stock_directionName,
          "stock-number": _ctx.upload_ftl_stock_scan.ftl_stock_number,
          onSubmitted: _ctx.uploadStockScanSubmit,
          onCancel: _ctx.uploadStockScanCancel
        }, null, 8, ["ftl-stock-id", "direction-name", "stock-number", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_ftl_order_state, {
          key: 6,
          "is-loading": _ctx.state.is_loading,
          "is-failed": _ctx.state.is_failed,
          onRetry: _ctx.loadFtlOrder
        }, null, 8, ["is-loading", "is-failed", "onRetry"]))
      : (_ctx.state.ftlOrder)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
            _createVNode(_component_ftl_order_header, {
              "order-status": _ctx.state.ftlOrder.status,
              "order-status-code": _ctx.state.ftlOrder.status_code,
              "is-billing-enabled": _ctx.state.ftlOrder.billing_enabled,
              "is-international-transportation": _ctx.state.ftlOrder.ftl_type === 1,
              "ftl-bid-id": _ctx.state.ftlOrder.ftl_bid_id,
              "payment-by-suppliers-id": _ctx.state.ftlOrder.payment_by_suppliers_id,
              scan: _ctx.state.ftlOrder.scan,
              "carrier-id": _ctx.state.ftlOrder.carrier_id,
              "is-need-car": _ctx.state.ftlOrder.is_need_car,
              "is-status-loading": _ctx.state.is_status_loading,
              "is-transcript-printing": _ctx.state.is_transcript_printing,
              "is-route-printing": _ctx.state.is_route_printing,
              "is-resending-to-one-c": _ctx.state.is_resending_to_one_c,
              "is-invoices-printing": _ctx.state.is_invoices_printing,
              "is-carrier-loading": _ctx.state.is_carrier_loading,
              "already-have-one-c": _ctx.state.is_already_have_one_c,
              "is-complete-loading": _ctx.state.is_complete_intracity_loading,
              "is-intracity": "",
              onAssignStatusOnTheWay: _ctx.assignStatusOnTheWayHandler,
              onCarrier: _ctx.toggleCarrier,
              onDelivered: _ctx.toggleDelivered,
              onPrintTranscript: _ctx.onPrintTranscript,
              onPrintRoute: _ctx.onPrintRoute,
              onAssignStatusCanceled: _ctx.assignStatusCanceled,
              onPrintInvoices: _ctx.onPrintInvoices,
              onDownloadScan: _ctx.onDownloadScan,
              onUploadScan: _ctx.onScanUploadHandler,
              onCompleteIntracity: _ctx.toggleCompleteIntracity,
              onResendToOneC: _ctx.onResendToOneC
            }, null, 8, ["order-status", "order-status-code", "is-billing-enabled", "is-international-transportation", "ftl-bid-id", "payment-by-suppliers-id", "scan", "carrier-id", "is-need-car", "is-status-loading", "is-transcript-printing", "is-route-printing", "is-resending-to-one-c", "is-invoices-printing", "is-carrier-loading", "already-have-one-c", "is-complete-loading", "onAssignStatusOnTheWay", "onCarrier", "onDelivered", "onPrintTranscript", "onPrintRoute", "onAssignStatusCanceled", "onPrintInvoices", "onDownloadScan", "onUploadScan", "onCompleteIntracity", "onResendToOneC"]),
            _createVNode(_component_ftl_order_tabs, {
              value: _ctx.state.currentTab,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.currentTab) = $event)),
              files: _ctx.ftlOrderFilesArray,
              "is-need-car": _ctx.state.ftlOrder?.is_need_car,
              "is-intracity": ""
            }, null, 8, ["value", "files", "is-need-car"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.state.currentTab === 'general')
                  ? (_openBlock(), _createBlock(_component_ftl_order_general, {
                      key: 0,
                      "ftl-bid-id": _ctx.state.ftlOrder.ftl_bid_id,
                      "ftl-type-name": _ctx.state.ftlOrder.ftl_type_name,
                      "dop-order-number": _ctx.state.ftlOrder.dop_order_number,
                      "shipment-type-name": _ctx.state.ftlOrder.shipment_type_name,
                      "take-date": _ctx.state.ftlOrder.take_date,
                      "take-time": _ctx.state.ftlOrder.take_time,
                      "act-number": _ctx.state.ftlOrder.act_number,
                      "act-created-at": _ctx.state.ftlOrder.act_created_at,
                      "auto-duration-client": _ctx.state.ftlOrder.auto_duration_client,
                      "auto-count": _ctx.state.ftlOrder.auto_count,
                      manager: _ctx.state.ftlOrder.manager,
                      "company-name": _ctx.state.ftlOrder.company_name,
                      annotation: _ctx.state.ftlOrder.annotation,
                      "created-at": _ctx.state.ftlOrder.created_at,
                      "received-by": _ctx.state.ftlOrder.received_by,
                      "delivery-date": _ctx.state.ftlOrder.delivery_date,
                      "auto-duration": _ctx.state.ftlOrder.auto_duration,
                      number: _ctx.state.ftlOrder.number,
                      "created-by": _ctx.state.ftlOrder.created_by,
                      "is-need-car": _ctx.state.ftlOrder.is_need_car
                    }, null, 8, ["ftl-bid-id", "ftl-type-name", "dop-order-number", "shipment-type-name", "take-date", "take-time", "act-number", "act-created-at", "auto-duration-client", "auto-count", "manager", "company-name", "annotation", "created-at", "received-by", "delivery-date", "auto-duration", "number", "created-by", "is-need-car"]))
                  : _createCommentVNode("", true),
                (_ctx.state.currentTab === 'cargo')
                  ? (_openBlock(), _createBlock(_component_ftl_order_cargo, {
                      key: 1,
                      "ftl-order": _ctx.state.ftlOrder
                    }, null, 8, ["ftl-order"]))
                  : _createCommentVNode("", true),
                (_ctx.state.currentTab === 'payment')
                  ? (_openBlock(), _createBlock(_component_ftl_order_payment, {
                      key: 2,
                      "ftl-order": _ctx.state.ftlOrder,
                      "sender-city": _ctx.senderCity,
                      "additional-service": _ctx.state.ftlOrder.shared_additional_service,
                      "payment-method": _ctx.state.ftlOrder.payment_method,
                      "declared-price": _ctx.state.ftlOrder.declared_price,
                      "payment-type": _ctx.state.ftlOrder.payment_type,
                      "is-prepayment": _ctx.state.ftlOrder.is_prepayment,
                      "cost-price-with-nds": _ctx.state.ftlOrder.cost_price_with_nds,
                      "company-name": _ctx.state.ftlOrder.company_name,
                      "ftl-type": _ctx.state.ftlOrder.ftl_type,
                      "payment-rate-type-id": _ctx.state.ftlOrder.payment_rate_type_id,
                      "cost-price-per-hour": _ctx.state.ftlOrder.cost_price_per_hour,
                      "cost-price": _ctx.state.ftlOrder.cost_price,
                      "cost-total": _ctx.state.ftlOrder.cost_total,
                      "paid-price-per-hour": _ctx.state.ftlOrder.paid_price_per_hour,
                      "paid-price": _ctx.state.ftlOrder.paid_price,
                      "paid-price-total": _ctx.state.ftlOrder.paid_price_total,
                      downtime: _ctx.state.ftlOrder.downtime
                    }, null, 8, ["ftl-order", "sender-city", "additional-service", "payment-method", "declared-price", "payment-type", "is-prepayment", "cost-price-with-nds", "company-name", "ftl-type", "payment-rate-type-id", "cost-price-per-hour", "cost-price", "cost-total", "paid-price-per-hour", "paid-price", "paid-price-total", "downtime"]))
                  : _createCommentVNode("", true),
                (_ctx.state.currentTab === 'sender-and-stops')
                  ? (_openBlock(), _createBlock(_component_ftl_order_sender_and_stops, {
                      key: 3,
                      "additional-service": _ctx.state.ftlOrder.additional_service,
                      sender: _ctx.state.ftlOrder.sender,
                      "stock-delivery-notes": _ctx.state.ftlOrder.stock_delivery_notes,
                      "is-uploading-scan": false,
                      "is-printing-invoice": _ctx.state.is_printing_stock_invoice,
                      onUploadScan: _ctx.uploadStockScanHandler,
                      onPrintInvoice: _ctx.printStockInvoiceHandler
                    }, null, 8, ["additional-service", "sender", "stock-delivery-notes", "is-printing-invoice", "onUploadScan", "onPrintInvoice"]))
                  : _createCommentVNode("", true),
                (_ctx.state.currentTab === 'vehicle-information')
                  ? (_openBlock(), _createBlock(_component_ftl_order_vehicle, {
                      key: 4,
                      "carrier-name": _ctx.state.ftlOrder.carrier_name,
                      "car-brand": _ctx.state.ftlOrder.car_brand,
                      cubature: _ctx.state.ftlOrder.cubature,
                      "loading-type": _ctx.state.ftlOrder.loading_type,
                      "car-info": _ctx.state.ftlOrder.car_info,
                      "cargo-name": _ctx.state.ftlOrder.cargo_name,
                      "car-number": _ctx.state.ftlOrder.car_number,
                      "driver-name": _ctx.state.ftlOrder.driver_name,
                      "driver-phone": _ctx.state.ftlOrder.driver_phone,
                      "load-capacity": _ctx.state.ftlOrder.load_capacity,
                      "oversized-cargo": _ctx.state.ftlOrder.oversized_cargo,
                      "trailer-license-number": _ctx.state.ftlOrder.trailer_license_number,
                      auto_duration: _ctx.state.ftlOrder.auto_duration
                    }, null, 8, ["carrier-name", "car-brand", "cubature", "loading-type", "car-info", "cargo-name", "car-number", "driver-name", "driver-phone", "load-capacity", "oversized-cargo", "trailer-license-number", "auto_duration"]))
                  : _createCommentVNode("", true),
                (_ctx.state.currentTab === 'files')
                  ? (_openBlock(), _createBlock(_component_ftl_order_files, {
                      key: 5,
                      files: _ctx.ftlOrderFilesArray
                    }, null, 8, ["files"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_ftl_order_statuses, {
                  statuses: _ctx.state.ftlOrder.order_statuses
                }, null, 8, ["statuses"])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}